import { render, staticRenderFns } from "./MagicCubePreview.vue?vue&type=template&id=611000a6&scoped=true"
import script from "./MagicCubePreview.vue?vue&type=script&lang=js"
export * from "./MagicCubePreview.vue?vue&type=script&lang=js"
import style0 from "./MagicCubePreview.vue?vue&type=style&index=0&id=611000a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611000a6",
  null
  
)

export default component.exports